var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.118 4.52563C8.36136 4.52563 4.52539 7.84558 4.52539 11.876C4.52539 14.4922 6.12116 16.783 8.5148 18.091L7.70465 21.3646C7.68937 21.4136 7.68702 21.4663 7.69786 21.5167C7.7087 21.5671 7.7323 21.6133 7.76602 21.65C7.81519 21.697 7.87845 21.7229 7.94401 21.7231C7.99837 21.7183 8.04994 21.6951 8.09131 21.6567L11.5774 19.1136C12.092 19.1905 12.6108 19.2303 13.1302 19.2331C17.8807 19.2331 21.7228 15.9131 21.7228 11.876C21.7228 7.83894 17.8684 4.52563 13.118 4.52563Z",
    fill: "#423630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/Kakao.7358db054547e0f76bfd7864e6da1725.svg";
export { ForwardRef as ReactComponent };